module.exports = __webpack_public_path__ + "img/gh-12132pin1.prt.adfa24c0.jpg";